import { createContext } from '@direct-frontend/modules-context';
import { ExperimentsFlags } from './experimentFlags';

export interface ExperimentsContext {
    experimentsFlags: ExperimentsFlags;
}

export const { setContext: setExperimentsContext, getContext: getExperimentsContext } =
    createContext<ExperimentsContext>({
        name: 'experimentsContext',
    });
